import { Hall, Student } from "../../interfaces";
import { HallRoom } from "../../interfaces";

export enum HallRoomActionTypes {
  FETCH_ROOMS_REQUEST = "@@hall/FETCH_ROOMS_REQUEST",
  FETCH_ROOMS_SUCCESS = "@@hall/FETCH_ROOMS_SUCCESS",
  FETCH_ROOMS_ERROR = "@@hall/FETCH_ROOMS_ERROR",
  FETCH_ROOM_REQUEST = "@@hall/FETCH_SINGLE_ROOM_REQUEST",
  FETCH_ROOM_SUCCESS = "@@hall/FETCH_SINGLE_ROOM_SUCCESS",
  FETCH_ROOM_ERROR = "@@hall/FETCH_SINGLE_ROOM_ERROR",
  CREATE_ROOM_REQUEST = "@@hall/CREATE_ROOM_REQUEST",
  CREATE_ROOM_SUCCESS = "@@hall/CREATE_ROOM_SUCCESS",
  CREATE_ROOM_ERROR = "@@hall/CREATE_ROOM_ERROR",
  UPDATE_ROOM_REQUEST = "@@hall/UPDATE_ROOM_REQUEST",
  UPDATE_ROOM_SUCCESS = "@@hall/UPDATE_ROOM_SUCCESS",
  UPDATE_ROOM_ERROR = "@@hall/UPDATE_ROOM_ERROR",
  DELETE_ROOM_REQUEST = "@@hall/DELETE_ROOM_REQUEST",
  DELETE_ROOM_SUCCESS = "@@hall/DELETE_ROOM_SUCCESS",
  DELETE_ROOM_ERROR = "@@hall/DELETE_ROOM_ERROR",
  FETCH_ROOMS_BY_HALL_REQUEST = "@@hall/FETCH_ROOMS_BY_HALL_REQUEST",
  FETCH_ROOMS_BY_HALL_SUCCESS = "@@hall/FETCH_ROOMS_BY_HALL_SUCCESS",
  FETCH_ROOMS_BY_HALL_ERROR = "@@hall/FETCH_ROOMS_BY_HALL_ERROR",
  CLEAR_ROOM_STATE = "@@hall/CLEAR_ROOM_STATE",
}

export type HallRoomState = {
  readonly isHallRoomSubmitting: boolean;
  readonly isHallRoomDeleting: boolean;
  readonly loading: boolean;
  readonly success: boolean;
  readonly failure: boolean;
  readonly error: any;
  readonly deleteSuccess: boolean;
  readonly hall: Hall | null;
  readonly floor: HallRoom | null;
  readonly rooms: HallRoom[];
  readonly room: HallRoom | null;
  readonly students: Student[];
  readonly page: string;
  readonly isRoomSubmitting: boolean;
  readonly isRoomDeleting: boolean;
};
